'use strict';

angular.module('atex.dam').directive('damCheckbox', ['$compile', function($compile) {    
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '',
    link: function (scope, element, attrs) {
      var divCheckBox = "<div class=\"dam-checkbox\">";
      divCheckBox +=    "<i ng-show=\"{true:true,false:false}["+attrs.damChecked+"]\" class=\"fa fa-check-square-o\" /></i>";
      divCheckBox +=    "<i ng-show=\"{true:false,false:true}["+attrs.damChecked+"]\" class=\"fa fa-square-o\" /></i>";
      divCheckBox +=    "</div>";
      element.prepend(divCheckBox);
      $compile(element.contents())(scope); 
    }
  };
}]);
